import { DailyTopTimes } from 'features/home/components/DailyTopTimes';
import React, { FC } from 'react';

interface DailyTimePageProps {
  match: {
    params: {
      date?: string;
    };
  };
}

export const DailyTimePage: FC<DailyTimePageProps> = ({
  match: { params: { date } }
}) => (
  <DailyTopTimes date={date} showDate />
);